/**
 * @generated SignedSource<<86d62ee106d4741bc38702c21c843e25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_transaction$data = {
  readonly buyerChargeCurrency: Currency | null;
  readonly isGiftEligible: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDutiesMessage_transaction" | "CheckoutGifting_transaction" | "CheckoutRestrictionAcknowledgement_transaction" | "CheckoutReturningBuyerDeliveryOptionsView_transaction" | "CheckoutReviewStepChargesDisclaimer_transaction" | "CheckoutReviewStepDeliveryView_transaction" | "CheckoutReviewTally_transaction" | "CheckoutSidebarPromotion_transaction" | "CheckoutStickySubmitButton_transaction" | "CheckoutSubmitButton_transaction" | "CheckoutTaxExemptionCheckbox_transaction" | "CheckoutVatReverseChargeCheckbox_transaction">;
  readonly " $fragmentType": "CheckoutReviewStep_transaction";
};
export type CheckoutReviewStep_transaction$key = {
  readonly " $data"?: CheckoutReviewStep_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepChargesDisclaimer_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRestrictionAcknowledgement_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepDeliveryView_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutGifting_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutVatReverseChargeCheckbox_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReturningBuyerDeliveryOptionsView_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutStickySubmitButton_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewTally_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGiftEligible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "buyerChargeCurrency",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "7ddc52b695a44a783a91d55df1517cf3";

export default node;
